import type { UUID } from '@aline/common';
import { Apollo } from 'src/gql/generated';
import { useAreWorkflowStepsEditable, useCheckWorkflowAuthorization } from 'src/hooks';

/**
 * Roles are filled on a running workflow by the owner's side, before it goes out for signature.
 * The same gates as the collaborator card's Assign button.
 */
export function useCanAssignWorkflowRoles(workflowId: UUID): boolean {
  const { areStepsEditable, workflow } = useAreWorkflowStepsEditable(workflowId);
  const { canEditWorkflow } = useCheckWorkflowAuthorization(workflowId);
  return (
    workflow?.variant === Apollo.WorkflowVariant.Contract &&
    Boolean(workflow.requesterInOwnerOrg) &&
    canEditWorkflow &&
    areStepsEditable
  );
}
